import * as z from 'zod/v4';

export const UnauthorizedErrorResponse = z.object({
  errorMessage: z.string(),
});
